import { create } from 'zustand';

interface MiniCartUIState {
  isOpen: boolean;
  /** Auto-close timer id so we can cancel/reset if another item is added. */
  closeTimer: ReturnType<typeof setTimeout> | null;
  open: () => void;
  close: () => void;
}

/**
 * Lightweight UI state for the post-add slideout. Kept separate from the cart
 * data store so cart changes don't re-render the slideout, and vice versa.
 */
export const useMiniCartUI = create<MiniCartUIState>((set, get) => ({
  isOpen: false,
  closeTimer: null,

  open: () => {
    // Cancel any pending auto-close — a fresh add resets the timer.
    const t = get().closeTimer;
    if (t) clearTimeout(t);
    const next = setTimeout(() => set({ isOpen: false, closeTimer: null }), 7000);
    set({ isOpen: true, closeTimer: next });
  },

  close: () => {
    const t = get().closeTimer;
    if (t) clearTimeout(t);
    set({ isOpen: false, closeTimer: null });
  },
}));
